(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maka-elixir-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maka-elixir-purchase')) {
    customElements.define('maka-elixir-purchase', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', () => this.update());
        this.update();
      }
      update() {
        const recurring = this.querySelector('input[type=radio]:checked').value === 'club';
        const plan = this.querySelector('[data-selling-plan]');
        if (plan) plan.disabled = !recurring;
        this.querySelector('[data-club-details]').hidden = !recurring;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maka-protocol-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maka-protocol-preview')) {
    customElements.define('maka-protocol-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('change', () => this.update());
        this.update();
      }
      update() {
        const kit = this.querySelector('[data-kit]').selectedOptions[0];
        const duration = this.querySelector('[data-duration]:checked');
        const premium = kit.dataset.name.toLowerCase().includes('premium');
        this.querySelector('[data-summary-kit]').textContent = kit.dataset.name;
        this.querySelector('[data-summary-duration]').textContent = duration.nextElementSibling.textContent;
        const price = premium ? duration.dataset.premiumPrice : duration.dataset.starterPrice;
        this.querySelector('[data-pack-price]').textContent = price || this.dataset.priceUnavailable;
        this.querySelector('[data-value]').hidden = (premium ? duration.dataset.premiumHasSaving : duration.dataset.starterHasSaving) !== 'true';
        this.querySelector('[data-reference-price]').textContent = premium ? duration.dataset.premiumReference : duration.dataset.starterReference;
        this.querySelector('[data-saving]').textContent = premium ? duration.dataset.premiumSaving : duration.dataset.starterSaving;
        this.querySelector('[data-pack-gift]').hidden = !(premium && duration.value === '3');
        this.querySelector('[data-pack-id]').value = premium ? duration.dataset.premiumVariant : duration.dataset.starterVariant;
        this.querySelector('[data-pack-submit]').disabled = (premium ? duration.dataset.premiumAvailable : duration.dataset.starterAvailable) !== 'true';
        this.querySelector('[data-starter]').hidden = premium;
        this.querySelector('[data-premium]').hidden = !premium;
        this.querySelectorAll('[data-contents]').forEach(el => {
          el.hidden = el.dataset.contents !== (premium ? 'premium-' : 'starter-') + duration.value;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
